import { engineComponent } from "neo-common";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Attributes } from "../Utils/Attributes";
import { GeneralConfigurationAttributes } from "../Components/Configuration";
import { GameManager } from "../Managers/GameManager";

/**
 * The symbol element is used for hold symbol special cases and handle symbol behaviour on screen.
 * @class Symbol
 * @extends SwitchElement
 */

@engineComponent(ComponentTypes.DisplayObject)
export class Symbol extends SwitchElement {
    //special symbol cases
    static CaseRotation: string = "ROTATION";
    static CaseBlur: string = "BLUR";

    static CaseEmpty: string = "EMPTY";
    static CaseNormal: string = "NORMAL";
    static CaseIdle: string = "IDLE";
    static CaseNowin: string = "NOWIN";
    static CaseWin: string = "WIN";
    static CaseCycle: string = "CYCLE";

    static CaseBigWin: string = "BIG_WIN";
    static CaseEpicWin: string = "EPIC_WIN";
    static CaseLegendaryWin: string = "LEGENDARY_WIN";
    static CaseLive: string = "LIVE";
    static CaseImpact: string = "IMPACT";
    static CaseImpactTease: string = "IMPACT_TEASE";
    static CaseTease: string = "TEASER";
    static CaseStick: string = "STICK";
    static CaseStuck: string = "STUCK";

    //offsets for symbol which has bigger dimension than standard symbols
    offsetX: number;
    offsetY: number;

    zIndex: number = 0;
    type: string;
    hasWinFrame: boolean;

    usedInPool: boolean;
    id: number;

    constructor() {
        super();

        //default values
        this.offsetX = 0;
        this.offsetY = 0;

        this.center = true;

        this.usedInPool = false;
        this.id = -1;

        this.hasWinFrame = true;
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    createByNode(node: Element): void {
        if (DEBUG) {
            if (node.hasAttribute(SymbolAttributes.DEBUG) && node.getAttribute(SymbolAttributes.DEBUG) === "true") {
                debugger;
            }
        }

        super.createByNode(node);

        this.offsetX = Attributes.assignFloatAttribute(node, SymbolAttributes.OFFSET_X, this.offsetX);
        this.offsetY = Attributes.assignFloatAttribute(node, SymbolAttributes.OFFSET_Y, this.offsetY);

        if (node.hasAttribute(SymbolAttributes.OFFSET)) {
            this.offsetX = parseFloat(node.getAttribute(SymbolAttributes.OFFSET));
            this.offsetY = parseFloat(node.getAttribute(SymbolAttributes.OFFSET));
        }

        this.zIndex = Attributes.assignFloatAttribute(node, SymbolAttributes.Z_INDEX, this.zIndex);
        this.type = Attributes.assignStringAttribute(node, SymbolAttributes.TYPE, this.type);

        this.hasWinFrame = Attributes.assignBooleanAttribute(node, "HasWinFrame", this.hasWinFrame);
    }

    /**
     * Get attributes from configuration and set up supported properties.
     * @method configurate
     * @param node is Element from xml
     * @return void
     */
    configurate(node: Element): void {
        if (node.hasAttribute(GeneralConfigurationAttributes.SYMBOL_WIDTH)) {
            this.symbolWidth = parseInt(node.getAttribute(GeneralConfigurationAttributes.SYMBOL_WIDTH));
        }

        if (node.hasAttribute(GeneralConfigurationAttributes.SYMBOL_HEIGHT)) {
            this.symbolHeight = parseInt(node.getAttribute(GeneralConfigurationAttributes.SYMBOL_HEIGHT));
        }
    }

    goToCase(s: string, emitEvent: boolean = false, force: boolean = false): void {
        if (
            (s === "NORMAL" || s === "ROTATION") &&
            (this.getCurrentCase() === "IMPACT" ||
                this.getCurrentCase() === "IDLE" ||
                this.getCurrentCase() === "IDLE_0" ||
                this.getCurrentCase() === "IDLE_1" ||
                this.getCurrentCase() === "IDLE_2" ||
                this.getCurrentCase() === "IDLE_3" ||
                this.getCurrentCase() === "IDLE_4")
        ) {
            return;
        }
        super.goToCase(s, emitEvent);
    }

    /**
     * Clone method used for cloning instance of this element with his main properties.
     * @method clone
     * @return Symbol
     */
    clone(): Symbol {
        let element: Symbol = new Symbol();

        element.elements = this.elements.clone();
        element.addChild(element.elements);

        element.style = this.style;
        element.offsetX = this.offsetX;
        element.offsetY = this.offsetY;
        element.symbolWidth = this.symbolWidth;
        element.symbolHeight = this.symbolHeight;
        element.visible = this.visible;
        element.case = this.case;
        element.style = this.style;
        element.zIndex = this.zIndex;
        element.type = this.type;
        element.hasWinFrame = this.hasWinFrame;

        element.markAsCloned(); // must be called last before return!
        return element;
    }
}

export const SymbolAttributes = {
    DEBUG: "Debug",
    /**
     *
     */
    OFFSET_X: "OffsetX",
    /**
     * OffsetY is difference between heigth of this symbol and standard symbol height divided by two.
     * @property OffsetX
     * @default 0
     */
    OFFSET_Y: "OffsetY",
    /**
     * Use offset property when offseX and offsetY is the same number.
     * @property Offset
     * @default 0
     */
    OFFSET: "Offset",
    /**
     * Z-index of symbol on screen
     * @property Zindex
     * @default 0
     */
    Z_INDEX: "Zindex",
    /**
     * Type of symbol. E.g.: wild
     */
    TYPE: "Type",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Symbol.ts
 **/